import { render, staticRenderFns } from "./Webrtc.vue?vue&type=template&id=626da5e2&scoped=true&"
import script from "./Webrtc.vue?vue&type=script&lang=js&"
export * from "./Webrtc.vue?vue&type=script&lang=js&"
import style0 from "./Webrtc.vue?vue&type=style&index=0&id=626da5e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626da5e2",
  null
  
)

export default component.exports